import { useState } from 'react';

import { youtubeThumbnailUrl, type YouTubeThumbnailSize } from '../../lib/youtube';

const FALLBACK_ORDER: YouTubeThumbnailSize[] = ['sd', 'hq', 'mq'];

type EpisodeThumbnailProps = {
  videoId: string;
  alt?: string;
  className?: string;
  sizes?: string;
};

/** YouTube episode still with automatic fallback when maxres is unavailable. */
export default function EpisodeThumbnail({
  videoId,
  alt = '',
  className,
  sizes = '(min-width: 992px) 320px, (min-width: 576px) 264px, 100vw',
}: EpisodeThumbnailProps) {
  const [sizeIndex, setSizeIndex] = useState(0);
  const sizesList = ['maxres', ...FALLBACK_ORDER] as YouTubeThumbnailSize[];
  const currentSize = sizesList[sizeIndex] ?? 'mq';
  const src = youtubeThumbnailUrl(videoId, currentSize);

  const srcSet = sizesList
    .map((size) => {
      const w = size === 'maxres' ? 1280 : size === 'sd' ? 640 : size === 'hq' ? 480 : 320;
      return `${youtubeThumbnailUrl(videoId, size)} ${w}w`;
    })
    .join(', ');

  function handleError() {
    setSizeIndex((i) => Math.min(i + 1, sizesList.length - 1));
  }

  return (
    <img
      className={className}
      src={src}
      srcSet={sizeIndex === 0 ? srcSet : undefined}
      sizes={sizeIndex === 0 ? sizes : undefined}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={handleError}
    />
  );
}
